<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<p class="calibre3"><span id="pgepubid00094" title="[87]"><a class="reference" id="Page_87"></a></span></p>
<h2 class="nobreak" id="III">III<br class="calibre7"/>
<span class="smaller">LETTER TO MARTIN VAN BUREN,<br class="calibre7"/>
PRESIDENT OF THE UNITED STATES</span></h2>
<p class="subheading">A PROTEST AGAINST THE REMOVAL OF THE
CHEROKEE INDIANS FROM THE
STATE OF GEORGIA</p>
</div>
<p class="calibre3"><span id="pgepubid00095" title="[88]"><a class="reference" id="Page_88"></a></span></p>
<div class="calibre5">
<div class="poetry">
<div class="stanza">
<div class="verse">“Say, what is Honour? ’Tis the finest sense</div>
<div class="verse">Of justice which the human mind can frame,</div>
<div class="verse">Intent each lurking frailty to disclaim,</div>
<div class="verse">And guard the way of life from all offence,</div>
<div class="verse">Suffered or done.”</div>
</div>
<div class="stanza">
<div class="verse1"><span class="smcap">Wordsworth.</span></div>
</div>
</div>
</div>
<p class="calibre3"><span id="pgepubid00096" title="[89]"><a class="reference" id="Page_89"></a></span></p>
<h3 class="calibre14 sigil_not_in_toc" id="pgepubid00097">LETTER<br class="calibre7"/>
<span class="smaller1">TO MARTIN VAN BUREN,<br class="calibre8"/>
PRESIDENT OF THE UNITED STATES</span></h3>
<p class="right"><span class="smcap">Concord, Mass.</span>, April 23, 1838.</p>
<p class="calibre3"><span class="smcap">Sir</span>: The seat you fill places you in a relation
of credit and nearness to every citizen.
By right and natural position, every citizen is
your friend. Before any acts contrary to his own
judgment or interest have repelled the affections
of any man, each may look with trust and living
anticipation to your government. Each has the
highest right to call your attention to such
subjects as are of a public nature, and properly
belong to the chief magistrate; and the good
magistrate will feel a joy in meeting such confidence.
In this belief and at the instance of
a few of my friends and neighbors, I crave of
your patience a short hearing for their sentiments
and my own: and the circumstance that
my name will be utterly unknown to you will
only give the fairer chance to your equitable
construction of what I have to say.</p>
<p class="calibre3">Sir, my communication respects the sinister
rumors that fill this part of the country concerning
the Cherokee people. The interest<span id="pgepubid00098" title="[90]"><a class="reference" id="Page_90"></a></span>
always felt in the aboriginal population—an
interest naturally growing as that decays—has
been heightened in regard to this tribe. Even
in our distant State some good rumor of their
worth and civility has arrived. We have learned
with joy their improvement in the social arts.
We have read their newspapers. We have seen
some of them in our schools and colleges. In
common with the great body of the American
people, we have witnessed with sympathy the
painful labors of these red men to redeem their
own race from the doom of eternal inferiority,
and to borrow and domesticate in the tribe the
arts and customs of the Caucasian race. And
notwithstanding the unaccountable apathy with
which of late years the Indians have been sometimes
abandoned to their enemies, it is not to
be doubted that it is the good pleasure and the
understanding of all humane persons in the
Republic, of the men and the matrons sitting
in the thriving independent families all over the
land, that they shall be duly cared for; that
they shall taste justice and love from all to
whom we have delegated the office of dealing
with them.</p>
<p class="calibre3">The newspapers now inform us that, in
December, 1835, a treaty contracting for the<span id="pgepubid00099" title="[91]"><a class="reference" id="Page_91"></a></span>
exchange of all the Cherokee territory was pretended
to be made by an agent on the part of
the United States with some persons appearing
on the part of the Cherokees; that the fact
afterwards transpired that these deputies did by
no means represent the will of the nation; and
that, out of eighteen thousand souls composing
the nation, fifteen thousand six hundred and
sixty-eight have protested against the so-called
treaty. It now appears that the government
of the United States choose to hold the Cherokees
to this sham treaty, and are proceeding to
execute the same. Almost the entire Cherokee
Nation stand up and say, “This is not our act.
Behold us. Here are we. Do not mistake that
handful of deserters for us;” and the American
President and the Cabinet, the Senate and the
House of Representatives, neither hear these
men nor see them, and are contracting to put
this active nation into carts and boats, and to
drag them over mountains and rivers to a wilderness
at a vast distance beyond the Mississippi.
And a paper purporting to be an army
order fixes a month from this day as the hour
for this doleful removal.</p>
<p class="calibre3">In the name of God, sir, we ask you if this
be so. Do the newspapers rightly inform us?<span id="pgepubid00100" title="[92]"><a class="reference" id="Page_92"></a></span>
Men and women with pale and perplexed faces
meet one another in the streets and churches
here, and ask if this be so. We have inquired
if this be a gross misrepresentation from the
party opposed to the government and anxious
to blacken it with the people. We have looked
in the newspapers of different parties and find
a horrid confirmation of the tale. We are slow
to believe it. We hoped the Indians were misinformed,
and that their remonstrance was premature,
and will turn out to be a needless act
of terror.</p>
<p class="calibre3">The piety, the principle that is left in the
United States, if only in its coarsest form, a regard
to the speech of men,—forbid us to entertain
it as a fact. Such a dereliction of all faith
and virtue, such a denial of justice, and such
deafness to screams for mercy were never heard
of in times of peace and in the dealing of a nation
with its own allies and wards, since the earth
was made. Sir, does this government think that
the people of the United States are become
savage and mad? From their mind are the sentiments
of love and a good nature wiped clean
out? The soul of man, the justice, the mercy
that is the heart’s heart in all men, from Maine
to Georgia, does abhor this business.</p>
<p class="calibre3"><span id="pgepubid00101" title="[93]"><a class="reference" id="Page_93"></a></span></p>
<p class="calibre3">In speaking thus the sentiments of my neighbors
and my own, perhaps I overstep the bounds
of decorum. But would it not be a higher indecorum
coldly to argue a matter like this? We
only state the fact that a crime is projected that
confounds our understandings by its magnitude,—a
crime that really deprives us as well as the
Cherokees of a country? for how could we call
the conspiracy that should crush these poor
Indians our government, or the land that was
cursed by their parting and dying imprecations
our country, any more? You, sir, will bring
down that renowned chair in which you sit into
infamy if your seal is set to this instrument of
perfidy; and the name of this nation, hitherto
the sweet omen of religion and liberty, will stink
to the world.</p>
<p class="calibre3">You will not do us the injustice of connecting
this remonstrance with any sectional and party
feeling. It is in our hearts the simplest commandment
of brotherly love. We will not have
this great and solemn claim upon national and
human justice huddled aside under the flimsy
plea of its being a party act. Sir, to us the
questions upon which the government and the
people have been agitated during the past year,
touching the prostration of the currency and of<span id="pgepubid00102" title="[94]"><a class="reference" id="Page_94"></a></span>
trade, seem but motes in comparison. These
hard times, it is true, have brought the discussion
home to every farmhouse and poor
man’s house in this town; but it is the chirping
of grasshoppers beside the immortal question
whether justice shall be done by the race of
civilized to the race of savage man,—whether all
the attributes of reason, of civility, of justice,
and even of mercy, shall be put off by the
American people, and so vast an outrage upon
the Cherokee Nation and upon human nature
shall be consummated.</p>
<p class="calibre3">One circumstance lessens the reluctance with
which I intrude at this time on your attention
my conviction that the government ought to be
admonished of a new historical fact, which the
discussion of this question has disclosed, namely,
that there exists in a great part of the Northern
people a gloomy diffidence in the <i class="calibre9">moral</i> character
of the government.</p>
<p class="calibre3">On the broaching of this question, a general
expression of despondency, of disbelief that any
good will accrue from a remonstrance on an act
of fraud and robbery, appeared in those men to
whom we naturally turn for aid and counsel.
Will the American government steal? Will it
lie? Will it kill?—We ask triumphantly. Our<span id="pgepubid00103" title="[95]"><a class="reference" id="Page_95"></a></span>
counsellors and old statesmen here say that ten
years ago they would have staked their lives on
the affirmation that the proposed Indian measures
could not be executed; that the unanimous
country would put them down. And now the
steps of this crime follow each other so fast, at
such fatally quick time, that the millions of virtuous
citizens, whose agents the government are,
have no place to interpose, and must shut their
eyes until the last howl and wailing of these
tormented villages and tribes shall afflict the ear
of the world.</p>
<p class="calibre3">I will not hide from you, as an indication of
the alarming distrust, that a letter addressed as
mine is, and suggesting to the mind of the
Executive the plain obligations of man, has a
burlesque character in the apprehensions of some
of my friends. I, sir, will not beforehand treat
you with the contumely of this distrust. I will
at least state to you this fact, and show you how
plain and humane people, whose love would
be honor, regard the policy of the government,
and what injurious inferences they draw as to
the minds of the governors. A man with your
experience in affairs must have seen cause to
appreciate the futility of opposition to the moral
sentiment. However feeble the sufferer and<span id="pgepubid00104" title="[96]"><a class="reference" id="Page_96"></a></span>
however great the oppressor, it is in the nature
of things that the blow should recoil upon the
aggressor. For God is in the sentiment, and
it cannot be withstood. The potentate and the
people perish before it; but with it, and as its
executor, they are omnipotent.</p>
<p class="calibre3">I write thus, sir, to inform you of the state
of mind these Indian tidings have awakened
here, and to pray with one voice more that you,
whose hands are strong with the delegated power
of fifteen millions of men, will avert with that
might the terrific injury which threatens the
Cherokee tribe.</p>
<p class="calibre3">With great respect, sir, I am your fellow
citizen,</p>
<p class="right">RALPH WALDO EMERSON.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?721fef05